import { GenericAdapter } from "./GenericAdapter";

export class BlingAdapter extends GenericAdapter {
  override readonly source = "bling";
  // Mantém o mapeamento manual funcional até a validação com um arquivo real do Bling.
}
